const words = [
    {
        text: {
            en: "Piano",
            "zh-CN": "钢琴",
            "zh-HK": "鋼琴"
        }, 
        weight: 50
    },
    {
        text: {
            en: "Kpop",
            "zh-CN": "Kpop",
            "zh-HK": "Kpop",
        }, 
        weight: 50
    },
    {
        text: {
            en: "Piano Arrangements",
            "zh-CN": "钢琴改编",
            "zh-HK": "鋼琴改編",
        }, 
        weight: 40
    },
    {
        text: {
            en: "NMIXX",
            "zh-CN": "NMIXX",
            "zh-HK": "NMIXX"
        }, 
        weight: 45
    },
    {
        text: {
            en: "Girls Group",
            "zh-CN": "女团",
            "zh-HK": "女團",
        }, 
        weight: 35
    },
    {
        text: {
            en: "H1-KEY",
            "zh-CN": "H1-KEY",
            "zh-HK": "H1-KEY",
        }, 
        weight: 30
    },
    {
        text: {
            en: "Anthem",
            "zh-CN": "战歌",
            "zh-HK": "戰歌",
        }, 
        weight: 25
    },
    {
        text: {
            en:"Ballad",
            "zh-CN": "芭乐",
            "zh-HK": "芭樂",
        }, 
        weight: 25
    },
    {
        text: {
            en: "Mix-pop",
            "zh-CN": "Mix-pop",
            "zh-HK": "Mix-pop",
        }, 
        weight: 30
    },
    {
        text: {
            en: "Kep1er",
            "zh-CN": "Kep1er",
            "zh-HK": "Kep1er",
        }, 
        weight: 25
    },
    {
        text: {
            en:"KISS OF LIFE",
            "zh-CN":"KISS OF LIFE",
            "zh-HK":"KISS OF LIFE",
        }, 
        weight: 25
    },
    {
        text: {
            en:"Classical Music",
            "zh-CN": "古典乐",
            "zh-HK": "古典樂",
        }, 
        weight: 40
    },
    {
        text: {
            en: "R&B",
            "zh-CN": "R&B",
            "zh-HK": "R&B",
        }, 
        weight: 15
    },
    {
        text: {
            en: "Rock",
            "zh-CN": "摇滚",
            "zh-HK": "搖滾",
        }, 
        weight: 15
    },
    {
        text: {
            en: "Youth",
            "zh-CN": "青春",
            "zh-HK": "青春",
        }, 
        weight: 20
    },
    {
        text: {
            en: "Passion",
            "zh-CN": "热爱",
            "zh-HK": "熱愛"
        }, 
        weight: 25
    },
];

const tagBgColors = ["bg-primary", "bg-info", "blue"]

export {
    words, 
    tagBgColors
};